import { withPlugins, eventBus, domEvents, device } from '@spon/plugins';

import Headroom from 'headroom.js';
// import toggle from '@/ui/toggle';
import { expander } from '@/utils/a11y';

function Header({ node, name, plugins: { addEvents, device } }) {
	if (!node) return;

	const searchForm = node.querySelector('[data-search]');
	let searchInput;

	const searchResultsElement = document.getElementById(
		'AlgoliaSearchResultsHeader'
	);
	const navLinks = [...node.querySelectorAll('.c-nav__list a')];

	const navButton = node.querySelector('.o-burger');
	const navTargetId = navButton.dataset.target;
	const navTarget = node.querySelector(`#${navTargetId}`);
	const navCheckbox = node.querySelector('#burger-checkbox');

	expander.init({ target: navTarget, button: navButton, id: navTargetId });

	// let searchIsOpen = false;
	// const searchToggle = node.querySelector('[data-searchToggle]');

	// Main Mobile Menu START
	let windowTop = 0;
	const lock = {
		capture() {
			windowTop = window.scrollY;
			document.body.style.position = 'fixed';
			document.body.style.top = `${windowTop * -1}px`;
			document.body.style.overflow = 'hidden';
			document.body.style.width = '100vw';

			// headroom.freeze();
		},
		release() {
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.overflow = '';
			document.body.style.width = '';
			if (windowTop) window.scroll(0, windowTop);

			// setTimeout(() => headroom.unfreeze(), 250);
		},
	};

	function clickWhenNavOpenHandle({ target }) {
		if (target.id === 'header' || target.closest('#header')) return; // Continue if clicking within #Header
		navClose();
	}

	function navOpen() {
		navButton.classList.add('nav-active');
		expander.open({ button: navButton, target: navTarget });
		lock.capture();

		document.addEventListener('click', clickWhenNavOpenHandle);
	}

	function navClose() {
		navCheckbox.checked = false;
		navButton.classList.remove('nav-active');
		expander.close({ button: navButton, target: navTarget });
		lock.release();
		closeSearch();

		document.removeEventListener('click', clickWhenNavOpenHandle);
	}

	function onNavClick() {
		if (navButton.classList.contains('nav-active')) {
			navClose();
		} else {
			navOpen();
		}
	}

	// Headroom
	const options = {
		offset: node.clientHeight * 1.25 || 0,
		tolerance: {
			up: 5,
			down: 0,
		},
	};
	const headroom = new Headroom(node, options);
	headroom.init();

	function clickWhenSearchOpenHandle({ target }) {
		if (
			target.id === 'HeaderSearch' ||
			target.closest('#Algolia-Header') ||
			target.hasAttribute('data-search-toggle')
		)
			return; // Continue if clicking within #HeaderSearch or initial button
		closeSearch();
	}

	function openSearch() {
		searchForm.classList.add('is-open');
		// searchIsOpen = true;
		// weird visual bug; wait for CSS to end then focus.
		if (!searchInput) {
			searchInput = node.querySelector('#AlgoliaSearchHeader input');
			if (searchInput) searchInput.focus();
		}

		document.addEventListener('click', clickWhenSearchOpenHandle);
	}

	function closeSearch() {
		node
			.querySelector('#AlgoliaSearchResultsHeader')
			.classList.remove('is-active');

		searchForm.classList.remove('is-open');
		if (searchInput) searchInput.blur();
		// searchIsOpen = false;

		document.removeEventListener('click', clickWhenSearchOpenHandle);

		searchResultsElement.removeAttribute('tabindex');
		navLinks.forEach(link => link.removeAttribute('tabindex'));
	}

	function onKeyDown(event) {
		const { code } = event;

		if (code === 'Escape') {
			navClose();
			closeSearch();
		}
	}

	function onSearchClick(event) {
		event.preventDefault();

		if (searchForm.classList.contains('is-open')) {
			closeSearch();
		} else {
			openSearch();
		}
	}

	eventBus.on('header:lock', () => lock.capture());
	eventBus.on('header:unlock', () => lock.release());

	addEvents({
		'click [data-menu-opener]': onNavClick,
		'click [data-search-toggle]': onSearchClick,
	});

	addEvents(document.body, {
		keydown: onKeyDown,
	});

	device.resize(() => {
		node
			.querySelector('#AlgoliaSearchResultsHeader')
			.classList.remove('is-active');
	});
}

export default withPlugins(domEvents, device)(Header);
